import * as Yup from 'yup';
import { columnMappingOptions } from '../helpers';

const ColumnMappingObj = Yup.object().shape({
  column: Yup.string(),
  index: Yup.number(),
});

const userSchema = Yup.object().shape({
  firstName: Yup.string(),
  lastName: Yup.string(),
  email: Yup.string(),
  existingUser: Yup.boolean(),
});

export const addUsersSchema = Yup.object().shape({
  isFirstRowHeaders: Yup.boolean(),
  isSkipExistingUsers: Yup.boolean(),
  arrayColumnMapping: Yup.array()
    .of(ColumnMappingObj)
    .test(
      'has all the required columns',
      'Please select the column names: First name, Last name, Email',
      (values) => {
        if (values) {
          const updatedArr = values.map((i) => i.column || '');
          return columnMappingOptions.every((option) => updatedArr.includes(option.value));
        }
        return false;
      }
    ),
  invitedUsers: Yup.array().of(userSchema),
});
